import { memo } from 'react'
import { NavLink } from 'react-router-dom'

import { Flex, Drawer, Divider, Button } from 'components/ui'
import { IconClearClose, IconCompany, IconExitApp, IconSettings, IconStudents, IconTransfer } from 'images/icons'


/** Свойства главного мобильного меню */
export interface IDrawerMenu {
    isOpen: boolean
    
    handlerButtonCancel?: () => void
    handlerOpenModalExitProgram?: () => void
}


/** Главное мобильное меню */
export const DrawerMenu = memo(({isOpen, handlerButtonCancel, handlerOpenModalExitProgram}: IDrawerMenu): JSX.Element => {
    return <Drawer isOpen={isOpen} isEsc isWrapper onCancel={handlerButtonCancel} maxWidth='300px' placement='right'>
        <Flex className='drawer_container'>
            <Flex direction='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                <h4>Основное меню</h4>

                <Button variant='icon' size='xs' onClick={handlerButtonCancel}>
                    <IconClearClose />
                </Button>
            </Flex>

            <Flex gap='4px' className='drawer_container-body'>
                <Flex gap='6px' className='drawer_container-content'>
                    <NavLink to='persons' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handlerButtonCancel}>
                        <IconStudents />
                        <p>Выпускники</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='companies' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handlerButtonCancel}>
                        <IconCompany />
                        <p>Контрагенты</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='transfer' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handlerButtonCancel}>
                        <IconTransfer />
                        <p>Передача данных</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>

                    <NavLink to='settings' className={({ isActive }) => isActive ? 'menu_button menu_button-active' : 'menu_button'} onClick={handlerButtonCancel}>
                        <IconSettings />
                        <p>Администрирование</p>
                    </NavLink>

                    <Divider variant='dark' margin='8px'/>
                    
                    <Button variant='icon' size='md' onClick={() => {handlerOpenModalExitProgram && handlerOpenModalExitProgram(); handlerButtonCancel && handlerButtonCancel()}}>
                        <IconExitApp />
                        <p>Выход</p>
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    </Drawer>
})